module.exports = __webpack_public_path__ + "static/img/team_honor_order.c6bda86d.png";